import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

interface TenantsHeaderProps {
  provider: string | undefined;
  theme: string | undefined;
  onProviderChange: (value: string) => void;
  onThemeChange: (value: string) => void;
  onProviderClear: () => void;
  onThemeClear: () => void;
  onNewTenant: () => void;
}

export const TenantsHeader: React.FC<TenantsHeaderProps> = ({
  provider,
  theme,
  onProviderChange,
  onThemeChange,
  onProviderClear,
  onThemeClear,
  onNewTenant,
}) => {
  return (
    <div className="grid mt-4">
      <div className="col-12 md:col-8">
        <div className="grid">
          <div className="col-12 md:col-6 p-inputgroup">
            <span className="p-float-label">
              <InputText
                className="w-full"
                id="provider"
                name="provider"
                onChange={(e) => onProviderChange(e.currentTarget.value)}
                value={provider || ""}
              />
              <label htmlFor="provider">Provider</label>
            </span>
            <Button
              icon="pi pi-times"
              className="p-button-danger"
              onClick={onProviderClear}
            />
          </div>
          <div className="col-12 md:col-6 p-inputgroup">
            <span className="p-float-label">
              <InputText
                className="w-full"
                id="theme"
                name="theme"
                onChange={(e) => onThemeChange(e.currentTarget.value)}
                value={theme || ""}
              />
              <label htmlFor="theme">Theme</label>
            </span>
            <Button
              icon="pi pi-times"
              className="p-button-danger"
              onClick={onThemeClear}
            />
          </div>
        </div>
      </div>
      <div className="col-12 md:col-4 flex justify-content-end align-items-center">
        <Button
          icon="pi pi-plus"
          label="Nuevo Tenant"
          onClick={onNewTenant}
          className="p-button-success"
        />
      </div>
    </div>
  );
}; 